var config = require("../config.js");
var UTILS = require("./utils.js");
var ahk = require("../../antihackkey.json");
module.exports = {
  ahNum: 0,
  socket: null,
  connected: false,
  socketId: -1,
  sendQueue: [],
  events: null,
  trackPacketStats: false,
  tickPacketCount: 0,
  ingressPacketCount: 0,
  ingressDataSize: 0,
  egressPacketCount: 0,
  egressDataSize: 0,
  connect(p9931, p9932, p9933) {
    if (!this.socket) {
      this.events = p9933;
      var v7980 = config.enableHttps ? "wss:" : "ws:";
      try {
        if (p9931.startsWith("http://")) {
          p9931 = p9931.slice(7);
        } else if (p9931.startsWith("https://")) {
          p9931 = p9931.slice(8);
        }
        var v7981 = false;
        var v7982 = v7980 + p9931;
        this.socket = new WebSocket(v7982);
        this.socket.binaryType = "arraybuffer";
        this.socket.onmessage = p9934 => {
          if (this.trackPacketStats) {
            this.ingressPacketCount++;
            this.ingressDataSize += p9934.data.byteLength;
          }
          var [v7983, v7984, v7985] = UTILS.decodePacket(p9934.data);
          if (v7984 === "k") {
            this.tickPacketCount++;
          }
          if (v7984 == "io-init") {
            this.socketId = v7985[0];
          } else if (v7984 == "cpt") {
            this._showCaptcha();
          } else if (v7984 == "cptR") {
            this._captchaComplete();
          } else {
            if (v7984 == "error") {
              this._hideCaptcha();
            }
            this._dispatchEvent(v7984, v7985);
          }
        };
        this.socket.onopen = () => {
          this.connected = true;
          p9932();
          for (let v7986 of this.sendQueue) {
            this.send(v7986[0], ...v7986[1]);
          }
        };
        this.socket.onclose = p9935 => {
          this.connected = false;
          if (!v7981) {
            p9932({
              error: "Disconnected. Try connecting to another server.",
              code: p9935 ? p9935.code : null,
              reason: p9935 ? p9935.reason : null
            });
          }
        };
        this.socket.onerror = p9936 => {
          v7981 = true;
          console.error("Socket error", p9936);
          p9932({
            error: "Socket error"
          });
        };
      } catch (e74) {
        console.error("Socket connection error:", e74);
        p9932({
          error: e74
        });
      }
    }
  },
  _dispatchEvent(p9937, p9938) {
    if (this.events[p9937]) {
      this.events[p9937].apply(undefined, p9938);
    }
  },
  send(p9939, ...Iiìíïïì) {
    if (!this.socket || this.socket.readyState !== WebSocket.OPEN) {
      console.warn("Socket sending on socket not open yet", this.socket.readyState);
      this.sendQueue.push([p9939, Iiìíïïì]);
      return;
    }
    if (p9939 != "cptR") {
      this.ahNum = UTILS.rotateNumber(this.ahNum, ahk);
    }
    var v7987 = UTILS.encodePacket(UTILS.serializePacket(p9939, ...Iiìíïïì), this.ahNum);
    this.socket.send(v7987);
    if (this.trackPacketStats) {
      this.egressPacketCount++;
      this.egressDataSize += v7987.byteLength;
    }
  },
  socketReady() {
    return this.socket && this.connected;
  },
  resetPacketTally() {
    this.tickPacketCount = 0;
    this.ingressPacketCount = 0;
    this.ingressDataSize = 0;
    this.egressPacketCount = 0;
    this.egressDataSize = 0;
  },
  close() {
    if (this.socket) {
      this.socket.close();
    }
  },
  captchaHolder: null,
  _showCaptcha() {
    if (this.captchaHolder != null) {
      console.warn("Already showing captcha");
      return;
    }
    if (!window.hcaptcha || !window.hcaptchaReady) {
      console.warn("Hcaptcha not loaded yet or not ready yet");
      requestAnimationFrame(this._showCaptcha.bind(this), 1000);
      return;
    }
    this.captchaHolder = document.createElement("div");
    this.captchaHolder.id = "captcha-holder";
    this.captchaHolder.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
    this.captchaHolder.style.zIndex = 999999;
    this.captchaHolder.style.position = "fixed";
    this.captchaHolder.style.top = "0";
    this.captchaHolder.style.left = "0";
    this.captchaHolder.style.bottom = "0";
    this.captchaHolder.style.right = "0";
    this.captchaHolder.style.pointerEvents = "all";
    uiBase.appendChild(this.captchaHolder);
    this.captchaModal = document.createElement("div");
    this.captchaModal.style.backgroundColor = "white";
    this.captchaModal.style.zIndex = 999999;
    this.captchaModal.style.position = "fixed";
    this.captchaModal.style.top = "50%";
    this.captchaModal.style.left = "50%";
    this.captchaModal.style.transform = "translate(-50%, -50%)";
    this.captchaModal.style.padding = "20px";
    this.captchaModal.style.borderRadius = "6px";
    this.captchaModal.style.boxShadow = "0px 9px 0px 0px #a6a6a6";
    this.captchaModal.style.width = "450px";
    this.captchaModal.style.display = "flex";
    this.captchaModal.style.textAlign = "center";
    this.captchaModal.style.flexDirection = "column";
    this.captchaModal.style.justifyContent = "center";
    this.captchaModal.style.alignItems = "center";
    this.captchaModal.style.pointerEvents = "all";
    this.captchaHolder.appendChild(this.captchaModal);
    let v7988 = document.createElement("div");
    v7988.style.fontSize = "32px";
    v7988.style.textTransform = "uppercase";
    v7988.style.marginBottom = "10px";
    v7988.textContent = "Security Challenge";
    this.captchaModal.appendChild(v7988);
    let v7989 = document.createElement("div");
    v7989.style.color = "rgba(0, 0, 0, 0.6)";
    v7989.style.fontSize = "20px";
    v7989.style.marginBottom = "10px";
    v7989.textContent = "Please complete the security challenge to continue";
    this.captchaModal.appendChild(v7989);
    let v7990 = document.createElement("div");
    this.captchaModal.appendChild(v7990);
    window.hcaptchaCallback = p9940 => {
      this.send("cptR", p9940);
    };
    window.hcaptchaErrorCallback = p9941 => {
      console.error("Hcaptcha error", p9941);
      this._hideCaptcha();
      this._dispatchEvent("error", ["CAPTCHA FAILED"]);
      this.close();
    };
    window.hcaptchaExpiredCallback = () => {
      this._hideCaptcha();
      this._dispatchEvent("error", ["CAPTCHA EXPIRED"]);
      this.close();
    };
    window.hcaptcha.render(v7990, {
      sitekey: "60a46f6a-e214-4aa8-b4df-4386e68dfde4",
      theme: "dark",
      callback: "hcaptchaCallback",
      "error-callback": "hcaptchaErrorCallback",
      "expired-callback": "hcaptchaExpiredCallback"
    });
  },
  _captchaComplete() {
    this._hideCaptcha();
  },
  _hideCaptcha() {
    if (this.captchaHolder) {
      this.captchaHolder.remove();
      this.captchaHolder = null;
      window.hcaptchaCallback = window.hcaptchaErrorCallback = window.hcaptchaExpiredCallback = null;
    }
  },
  reset() {
    this.ahNum = 0;
    if (this.socket) {
      this.socket.onclose = function () {};
      this.socket.close();
      this.socket = null;
    }
    this.connected = false;
    this.socketId = -1;
    this.sendQueue.length = 0;
    this.events = null;
    this.tickPacketCount = 0;
    this.ingressPacketCount = 0;
    this.ingressDataSize = 0;
    this.egressPacketCount = 0;
    this.egressDataSize = 0;
    if (this.captchaHolder) {
      this.captchaHolder.remove();
      this.captchaHolder = null;
    }
    if (this.captchaModal) {
      this.captchaHolder.remove();
      this.captchaHolder = null;
    }
  }
};